import {XeroSignupState} from '../state';
import {KeyValue} from '../types/Types';
import {Action} from '@planday-corp/react-app';

export type XeroSignupAction =
  | Action<
      'xeroSignup/INIT',
      {
        signupRequestId: string;
        source?: string;
        signupOrigin?: string;
        error?: string;
      }
    >
  | Action<
      'xeroSignup/RECEIVE',
      {
        content: Partial<XeroSignupState<string>>;
      }
    >
  | Action<'xeroSignup/UPDATE_FIELD', KeyValue>
  | Action<'xeroSignup/SAVE'>
  | Action<'xeroSignup/FETCH_FORM_DATA'>
  | Action<
      'xeroSignup/SET_TENANT_ID',
      {
        tenantId: string;
      }
    >
  | Action<
      'xeroSignup/PROCEED',
      {
        tenantId?: string;
      }
    >
  | Action<'xeroSignup/REDIRECT_TO_PORTAL'>;

export type ActionTypes = XeroSignupAction['type'];

export const actions = {
  init(
    signupRequestId: string,
    source?: string,
    signupOrigin?: string,
    error?: string
  ): XeroSignupAction {
    return {
      type: 'xeroSignup/INIT',
      payload: {signupRequestId, source, signupOrigin, error},
    };
  },
  receive(content: Partial<XeroSignupState<string>>): XeroSignupAction {
    return {type: 'xeroSignup/RECEIVE', payload: {content}};
  },
  updateField(payload: KeyValue): XeroSignupAction {
    return {
      type: 'xeroSignup/UPDATE_FIELD',
      payload,
    };
  },
  save(): XeroSignupAction {
    return {type: 'xeroSignup/SAVE', payload: undefined};
  },
  fetchFormData(): XeroSignupAction {
    return {type: 'xeroSignup/FETCH_FORM_DATA', payload: undefined};
  },
  setTenantId(tenantId: string): XeroSignupAction {
    return {type: 'xeroSignup/SET_TENANT_ID', payload: {tenantId}};
  },
  proceed(tenantId?: string): XeroSignupAction {
    return {type: 'xeroSignup/PROCEED', payload: {tenantId}};
  },
  redirectToPortal(): XeroSignupAction {
    return {type: 'xeroSignup/REDIRECT_TO_PORTAL', payload: undefined};
  },
};
